import { useHits } from "react-instantsearch"
import { AlgoliaProductHit } from "../../types/AlgoliaTypes";
import { useLocation, useNavigate } from "react-router-dom";

interface ProductHitsProps {
    clearQuery: () => void
}

export default function ProductHits({clearQuery}: ProductHitsProps) {

    const { hits } = useHits<AlgoliaProductHit>();
    const navigate = useNavigate();
    const location = useLocation();

    const handleProductClick = (objectID: string) => {
        navigate(`/finishes/search?productLineAvailability=${encodeURIComponent(objectID)}&initialClose=true`);
        clearQuery();
    }

    return (
        <div> 
            { hits.length > 0 ? <div className={"finish-search-box__product-results-subtitle"}>{window.steelcase_i18n["steelcase-finish-library"].search && window.steelcase_i18n["steelcase-finish-library"].search.products ? window.steelcase_i18n["steelcase-finish-library"].search.products : "Products"}</div> : null} 
            {
                hits.map((hit, idx) => {
                    return (
                        location.pathname.includes("products") || location.pathname.includes("produkte") || location.pathname.includes("produits") || location.pathname.includes("productos") ?
                            <div key={idx} className={"finish-search-box__product-results-search-item"}>
                                <a href={`https://${window.steelcase_finish_library.siteUrl.host}${window.steelcase_finish_library.siteUrl.path}finishes/search?productLineAvailability=${hit.objectID}&initialClose=true`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#191919", lineHeight: "1.33" }}>
                                    {hit.objectID}
                                </a>
                            </div>
                            :
                            <div key={idx} className={"finish-search-box__product-results-search-item"} onClick={() => handleProductClick(hit.objectID)}>
                                {
                                    hit.objectID
                                }
                            </div>
                    )
                })
            }
        </div>
    )
}